import Vue from 'vue';

import MixinRouting from './Routing';
import MixinPage from './Page';

export default {
    name: 'vue',

    dependencies: {
        MixinRouting,
        MixinPage,
    },

    hooks: {
        app: {
            init(registry) {
                // Wait for vue to be loaded.
                if (
                    registry.MixinRouting === 'complete' &&
                    registry.MixinPage === 'complete'
                ) {
                    this.addLib('vue', Vue);

                    let app = this;
                    this.vueGlobalMixin = {
                        props: {
                            app: {
                                default: () => {
                                    return app;
                                },
                            },
                        },
                    };

                    app.mix(this.vueGlobalMixin, 'vue');

                    this.lib.vue.mixin(this.vueGlobalMixin);

                    return 'complete';
                }
                return 'wait';
            },
        },
    },

    methods: {
        app: {
            buildSingleComponent(el, module, tagName = null, options = {}) {
                el = typeof el === 'string' ? document.querySelector(el) : el;
                tagName = tagName || el.tagName.toLowerCase();

                this.lib.vue.component(tagName, module.default);

                return new this.lib.vue({
                    ...{
                        el: el,
                        app: this,
                    },
                    ...options,
                });
            },
        },

        vue: {
            methods: {
                emitBubblingCustomEvent(name, options) {
                    this.$el.dispatchEvent(
                        new CustomEvent(name, {
                            ...options,
                            ...{
                                details: {
                                    component: this,
                                },
                                bubbles: true,
                            },
                        })
                    );
                },

                subItems(itemsList) {
                    let output = [];

                    for (let i in itemsList) {
                        if (i !== 'hydra:view') {
                            output.push(itemsList[i]);
                        }
                    }

                    return output;
                },
            },
        },
    },
};
